export default __webpack_public_path__ + "static/media/carbon_dashboard.6d9e496b.svg";